var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPretestNonSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Icon_-_Pretest_-_Non_Selected",
    width: 24,
    height: 24,
    "data-name": "Icon - Pretest - Non Selected",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#fff;opacity:0}.prefix__cls-3{fill:none;stroke:#afafaf;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.5px}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__icon",
    d: "M0 0H24V24H0z",
    className: "prefix__cls-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon_-_Pretest_-_Non_Selected-2",
    "data-name": "Icon - Pretest - Non Selected",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__frame",
    d: "M0 0H16V16H0z",
    className: "prefix__cls-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_3612",
    "data-name": "Group 3612",
    transform: "translate(.8 .8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6227",
    fill: "none",
    stroke: "#afafaf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2px",
    d: "M1 8.2V3.4A2.4 2.4 0 0 1 3.4 1H13a2.4 2.4 0 0 1 2.4 2.4V13a2.4 2.4 0 0 1-2.4 2.4H3.4A2.4 2.4 0 0 1 1 13v-1.642h2.714",
    "data-name": "Path 6227",
    transform: "translate(-1 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Stroke_1",
    d: "M11.787 7.692a2.4 2.4 0 1 0-4.8-.006 2.494 2.494 0 0 0 1.037 2.038v.534a.458.458 0 0 0 .451.465H10.3a.458.458 0 0 0 .451-.465v-.534a2.493 2.493 0 0 0 1.036-2.032z",
    className: "prefix__cls-3",
    "data-name": "Stroke 1",
    transform: "translate(-2.197 -1.843)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Stroke_3",
    d: "M10.541 14.654H9.064",
    className: "prefix__cls-3",
    "data-name": "Stroke 3",
    transform: "translate(-2.613 -3.731)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPretestNonSelected);
export default __webpack_public_path__ + "static/media/icon-pretest-non-selected.ca7f0d568f173830e4f44170e3e2a9a5.svg";
export { ForwardRef as ReactComponent };